export default {
  text: '#262d3d',
  primary: '#4b592cc7',
  secondary: '#a26a47',
  tertiary: '#e05333',
  background: '#f2e0bf',
  backgroundSecondary: '#65594f',
  light: '#FFF',
  dark: '#050707',
};
